import React from 'react';
import Particle from './../../Particle';
import {Paragraph, Image, Title} from './../../Basics';

const Particle11 = () => (<div>

  <Title>Die Idee hinter dem Wettkampf</Title>

  <Image
    source={require('./cybathlon_DIV_08(1)_cropped.jpg')}
    title='Portrait Robert Riener'
    caption='Robert Riener, Initiator des Cybathlon-Wettkampfs. Foto: ETHZ'
  />

  <Paragraph>
    «Die Idee zum Cybathlon kam mir vor fast vier Jahren durch einen Zeitungsartikel. 
    Darin las ich von einem Rennen, bei dem jemand 100 Stockwerke eines Hochhauses in 
    Chicago hochgelaufen ist – mit einer modernen motorisierten Beinprothese, die einem 
    richtigen Bein nachempfunden ist. Das sollte den neusten Stand der Forschung zeigen. 
    Ich dachte: So ein Event, aber noch viel grösser und in mehreren Disziplinen, können 
    wir auch in der Schweiz organisieren. Warum? Um die Entwicklung von robotischen 
    Hilfsmitteln für körperbehinderte Menschen voranzutreiben.
    </Paragraph>
    
    <Paragraph>
    <h3>Betroffene sind oft unzufrieden mit dem, was heutige Prothesen oder Rollstühle bieten.</h3>
    </Paragraph>
    
   <Paragraph> 
    Die Technik ist zu schlecht entwickelt. Manche Rollstühle schaffen nicht mal einen Bordstein. 
    Armprothesen sind unbequem zu tragen, verursachen manchmal sogar Druckgeschwüre und sind für 
    einfache Dinge, wie ein kleines Marmeladenglas zu öffnen, oft nicht zu brauchen. Und die 
    asymmetrische Bewegung, zu der Beinprothesen ihre Träger zwingen, vor allem beim Aufwärtslaufen, 
    macht ihnen die Gelenke kaputt. Zu oft setzen sich die Entwickler nicht mit den Betroffenen 
    zusammen, um ihre wirklichen Bedürfnisse zu erfahren. Der Cybathlon soll dazu beitragen, das 
    zu ändern. Und das Thema an die Öffentlichkeit bringen.  
    </Paragraph>
    
    <Paragraph>
    <h3>Viele Menschen haben durch Hollywood eine falsche Vorstellung.</h3>
    </Paragraph>
   
   <Paragraph>
    Zum Beispiel davon, was heutige Exoskelette können: Anders als in Filmen zu sehen, steht die 
    Entwicklung dieser Stützapparate für Querschnittgelähmte noch ganz am Anfang. Am Cybathlon 
    werden wir die besten Modelle zu sehen bekommen, die es gibt. Selbst das US-Militär hat 
    nichts besseres. Und doch: Nur um den kurzen Parcours am Cybathlon zu bewältigen, brauchen 
    die Teilnehmer ihre ganze Kraft und Konzentration.  
   </Paragraph>
   
  <Particle
    number={22}
  />

  <Paragraph>
    Es wird vielleicht noch 50 Jahre dauern, bis die Technik so gut ist, dass sie den Rollstuhl 
    ersetzt und sie selbst Gesunden im Alltag einen Vorteil bringt. Zum Beispiel mehr Kraft oder 
    Schnelligkeit. Dann wird ein Exoskelett vielleicht zu einem so normalen Hilfsmittel wie ein 
    Auto oder Smartphone.»
  </Paragraph>

</div>);

export default Particle11;



/** WEBPACK FOOTER **
 ** ./src/Particles/Particle11/Particle11.js
 **/